module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-home-c0fcd2d75395ef1d196ca627fcb5b0ec.webp";